// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__ShowContainer___1fmvh{display:block}.index__HideContainer___37Fy1,.index__ShowContainer___1fmvh{height:100%;overflow:hidden;-webkit-overflow-scrolling:touch;width:100%}.index__HideContainer___37Fy1{display:none}", ""]);
// Exports
exports.locals = {
	"ShowContainer": "index__ShowContainer___1fmvh",
	"HideContainer": "index__HideContainer___37Fy1"
};
module.exports = exports;
